import "./Print.css";

import React, { useCallback, useEffect, useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { CiStar } from "react-icons/ci";
import ReactStars from "react-rating-stars-component";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { RiDownload2Fill } from "react-icons/ri";
import {
  getAssignedStaffsQuestionsListPath,
  getQuestionAnswerForStaffListPath,
} from "../../../services/config";
import {
  commonGetData,
  initCommonState,
} from "../../../redux/slices/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";

const AnswerByEmployee = () => {
  const user = JSON.parse(localStorage.getItem("user_data")) || {};
  const [searchParams] = useSearchParams();
  const outletId = searchParams.get("outletId");
  const staffId = searchParams.get("staffId");
  const staffName = searchParams.get("staffName");
  const auditModelId = searchParams.get("auditModelId");
  const frequency = searchParams.get("frequency");

  const dispatch = useDispatch();
  const commonStore = useSelector((state) => state.common);

  const [auditQuestions, setAuditQuestions] = useState([]);
  const [questionAnswers, setQuestionAnswers] = useState([]);

  // const getAnswer = useCallback(() => {
  //   dispatch(
  //     commonGetData(
  //       getQuestionAnswerForStaffListPath(
  //         user.user_id,
  //         auditModelId,
  //         outletId,
  //         frequency,
  //         staffId
  //       )
  //     )
  //   );
  // }, []);

  // useEffect(() => {
  //   getAnswer();
  // }, []);

  useEffect(() => {
    // if(commonStore.commonGetSuccess || commonStore.commonGetError){
    //   console.log(commonStore.commonGetData)
    // }
    const auditAnswer = JSON.parse(localStorage.getItem("auditAnswer")) || [];
    if (auditAnswer) {
      setAuditQuestions(auditAnswer.auditQuestions);
      setQuestionAnswers(auditAnswer.questionAnswers);
    }
  }, []);

  const renderField = (field, index) => {
    console.log(field);
    switch (field.type) {
      case "Text":
        return (
          <div className="mb-3">
            {/* {field.value !== "formTitle" && ( */}
            <input
              type="text"
              value={field.value}
              placeholder="Will get user responses"
              readOnly
            />
            {/* )} */}

            <Row className="mt-2">
              {field.isFileUpload && (
                <Col sm="12" className="mb-2">
                  <Link to={field.answer[0].fileName} target="blanc_">
                    {" "}
                    <img
                      src={field.answer[0].fileName}
                      width="100px"
                      alt="img"
                    />
                  </Link>
                </Col>
              )}
              {field.rating > 0 && (
                <Col
                  sm="12"
                  className="mb-2"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "10px",
                  }}
                >
                  <label>Rating</label>
                  <label>
                    {" "}
                    <ReactStars
                      count={field.rating} // Total stars
                      value={field.answer[0].ratingAnswer} // Dynamic rating value
                      size={20} // Star size
                      activeColor="#ffd700" // Active star color
                      edit={false} // Disable editing
                      isHalf={true} // Enable half-star
                    />
                  </label>
                </Col>
              )}
            </Row>
          </div>
        );
      case "Dropdown":
        return (
          <div>
            <div>
              <select value={field.value} readOnly>
                <option value="">Select</option>
                {field.options?.map((option, i) => (
                  <option key={i} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              <Row className="mt-2">
                {field.isFileUpload && (
                  <Col sm="12" className="mb-2">
                    <img
                      src={field.answer[0].fileName}
                      width="100px"
                      alt="img"
                    />
                  </Col>
                )}

                {field.rating > 0 && (
                  <Col
                    sm="12"
                    className="mb-2"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: "10px",
                    }}
                  >
                    <label>Rating</label>
                    <label>
                      {" "}
                      <ReactStars
                        count={field.rating} // Total stars
                        value={field.answer[0].ratingAnswer} // Dynamic rating value
                        size={20} // Star size
                        activeColor="#ffd700" // Active star color
                        edit={false} // Disable editing
                        isHalf={true} // Enable half-star
                      />
                    </label>
                  </Col>
                )}
              </Row>
            </div>
          </div>
        );
      case "Multi Choice":
      case "Checkbox":
        return (
          <div className="mb-2">
            <div>
              {field.options?.map((option, i) => (
                <div
                  key={i}
                  className={
                    field.type === "Checkbox"
                      ? "checkbox-option"
                      : "radio-option"
                  }
                >
                  <input
                    type={field.type === "Checkbox" ? "checkbox" : "radio"}
                    name={field.label}
                    value={option}
                    checked={
                      field.type === "Checkbox"
                        ? field.value.includes(option)
                        : field.value === option
                    }
                    readOnly
                  />
                  {option}
                </div>
              ))}

              <Row className="mt-2">
                {field.isFileUpload == true && (
                  <Col sm="12" className="mb-2">
                    <img
                      src={field.answer[0].fileName}
                      width="100px"
                      alt="img"
                    />
                  </Col>
                )}

                {field.rating > 0 && (
                  <Col
                    sm="12"
                    className="mb-2"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: "10px",
                    }}
                  >
                    <label>Rating</label>
                    <label>
                      {" "}
                      <ReactStars
                        count={field.rating} // Total stars
                        value={field.answer[0].ratingAnswer} // Dynamic rating value
                        size={20} // Star size
                        activeColor="#ffd700" // Active star color
                        edit={false} // Disable editing
                        isHalf={true} // Enable half-star
                      />
                    </label>
                  </Col>
                )}
              </Row>
            </div>
          </div>
        );
      case "File Upload":
        return (
          <div className="mb-3">
            <Col sm="12" className="mb-2">
              <Link to={field.answer[0].fileName} target="blanc_">
                {" "}
                <img src={field.answer[0].fileName} width="100px" alt="img" />
              </Link>
            </Col>
          </div>
        );

      case "Date":
        const formattedDate = field.value
          .split("-")
          .map((part) => part.padStart(2, "0"))
          .join("-");
        return (
          <div className="mb-3">
            <input type="date" value={formattedDate} readOnly />
            <Row className="mt-2">
              {field.isFileUpload && (
                <Col sm="12" className="mb-2">
                  <Link to={field.answer[0].fileName} target="blanc_">
                    {" "}
                    <img
                      src={field.answer[0].fileName}
                      width="100px"
                      alt="img"
                    />
                  </Link>
                </Col>
              )}

              {field.rating > 0 && (
                <Col
                  sm="12"
                  className="mb-2"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "10px",
                  }}
                >
                  <label>Rating</label>
                  <label>
                    <ReactStars
                      count={field.rating} // Total stars
                      value={field.answer[0].ratingAnswer} // Dynamic rating value
                      size={20} // Star size
                      activeColor="#ffd700" // Active star color
                      edit={false} // Disable editing
                      isHalf={true} // Enable half-star
                    />
                  </label>
                </Col>
              )}
            </Row>
          </div>
        );
      case "time":
        return <input type="time" value={field.value} />;
      default:
        return null;
    }
  };

  const divRef = useRef(); // Reference to the div to print

  const handlePrint = () => {};

  return (
    <div>
      <div className="page-top-bar" style={{ height: "40px" }}>
        <div
          style={{
            position: "relative",
            top: "10px",
            display: "flex",
            alignItem: "center",
            justifyContent: "start",
            gap: "10px",
          }}
        >
          <Link
            onClick={() => localStorage.removeItem("auditAnswer")}
            to={`/audit-question-list?outletId=${outletId}&staffId=${staffId}&staffName=${staffName}`}
          >
            <ArrowBackIcon sx={{ scale: 1 }} style={{ color: "gray" }} />
          </Link>
          <h1
            style={{
              fontSize: "20px",
              fontWeight: "400",
              position: "relative",
              top: "-3px",
            }}
          >
            {staffName}
          </h1>
        </div>
      </div>

      <div className="answer-form">
        <RiDownload2Fill
          className="download-icon"
          onClick={handlePrint}
          style={{
            position: "fixed",
            right: "10px",
            top: "40px",
            cursor: "pointer",
            fontSize: 20,
            color: "lime",
            marginRight: "10px",
            zIndex: "2",
          }}
        />
        <div ref={divRef} className="form-preview">
          {/* Question List ------------- */}

          <div style={{ position: "relative", top: "15px" }}>
            <h3 className="mb-3">Questions:</h3>

            {auditQuestions?.map((que, idx) => {
              return (
                <label key={idx}>
                  {idx + 1}. {que.label}
                </label>
              );
            })}
          </div>

          {/* {questionAnswers?.map((field, index) => (
            <div key={index}>
              <hr style={{ border: "1px solid lightgray" }} />

              <label>
                {index + 1}.  &nbsp; {field.label}
              </label>
              {renderField(field, index)}
            </div>
          ))} */}

          <h3 className="mt-3">Answers:</h3>
          {questionAnswers?.map((field, index) => (
            <div key={index}>
              <hr style={{ border: "1px solid lightgray" }} />

              <label style={{ fontWeight: "bold" }}>{field.date}</label>
              {field.answers == "Not Done"
                ? "Not Done"
                : field.answers?.map((ans, ansIdx) => {
                    return (
                      <div>
                        <label>
                          {ansIdx + 1}. &nbsp; {ans.label}
                        </label>
                        {renderField(ans, ansIdx)}
                      </div>
                    );
                  })}
              {field.overallRating > 0 && (
                <label style={{ fontWeight: "bold" }}>
                  Overall Rating: {field.overallRating}
                </label>
              )}
            </div>
          ))}

          {/* 

 
                : field.answers?.map((ans, ansIdx) => (
                  <label>
                  {ansIdx + 1}.  &nbsp; {ans.label}
                </label>
                  {renderField(ans, ansIdx))

*/}
        </div>
      </div>
    </div>
  );
};

export default AnswerByEmployee;
